import React, { useEffect, useState, useRef, Fragment } from 'react';


import { useFormik } from 'formik';
import { InputText } from 'primereact/inputtext';
import { classNames } from 'primereact/utils';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';

import { toastShow } from '../../../../Base/Services/ToastService';

import { modificarRol } from '../../../../API/IT/Roles/RolesRequests';

export const ModificarRolModal = ({ datos, setDatos, updateRoles }) => {
    const toast = useRef(null);

    const [rolDialog, setRolDialog] = useState(false);
    const [loading, setLoading] = useState(false);

    const editRol = async (newData) => {
        setLoading(true);
        const data = {
            IdRol: newData.IdRol,
            Rol: newData.Rol,
            Description: newData.Description
        }
        const p = await modificarRol(newData.IdRol, data);
        updateRoles()
        toastShow(toast, 'success', 'Modificdo', 'Rol modificado.');
        hideDialog();
        setLoading(false);
    }

    const hideDialog = () => {
        setRolDialog(false);
        setDatos(null);
    }

    const formik = useFormik({
        initialValues: datos,
        validate: (data) => {
            let errors = {};

            if (!data?.Rol) {
                errors.Rol = 'El rol es requerido.';
            }

            return errors;
        },
        onSubmit: async (data) => {
            await editRol(data);
        }
    });

    useEffect(() => {
        console.log(datos);
        formik.setValues(datos);
    }, [datos])


    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    return (
        <Fragment>
            <Toast position="bottom-right" ref={toast}></Toast>
            <Dialog visible={datos !== null} breakpoints={{ '960px': '75vw', '640px': '100vw' }} style={{ width: '40vw' }} onHide={hideDialog}>
                <div style={{ width: '100%', margin: 'auto' }}>
                    <h2>Modificar Rol</h2>
                    <form onSubmit={formik.handleSubmit} className="p-fluid">
                        <div className="field" style={{ marginTop: 30 }}>
                            <span className="p-float-label">
                                <InputText id="Rol" name="Rol" value={formik.values?.Rol} onChange={formik.handleChange} autoFocus className={classNames({ 'p-invalid': isFormFieldValid('Rol') })} />
                                <label htmlFor="Rol" className={classNames({ 'p-error': isFormFieldValid('Rol') })}>Rol</label>
                            </span>
                            {getFormErrorMessage('Rol')}
                        </div>
                        <div className="field" style={{ marginTop: 30 }}>
                            <span className="p-float-label">
                                <InputText id="Description" name="Description" value={formik?.values?.Description} onChange={formik.handleChange} className={classNames({ 'p-invalid': isFormFieldValid('Description') })} />
                                <label htmlFor="Description" className={classNames({ 'p-error': isFormFieldValid('Descripcion') })}>Description</label>
                            </span>
                            {getFormErrorMessage('Description')}
                        </div>
                        <div className="p-dialog-footer">
                            <Button label="Cancelar" type='button' icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
                            <Button type='submit' label="Guardar" loading={loading} icon="pi pi-check" className="p-button-text" />
                        </div>
                    </form>
                </div>

            </Dialog>
        </Fragment>
    )
}

export default ModificarRolModal;